import type { BuildingProps } from '~/types/crafting';
import { Buildings } from './buildings';

export const EXPEDITION_BUILDINGS: BuildingProps[] = [
  {
    buildingName: 'forest',
    buildingKey: Buildings.Forest,
    buildingHash: 'forest',
    buildingId: 'forest',
    descriptionKey: 'forest_description'
  },
  {
    buildingName: 'cave',
    buildingKey: Buildings.Cave,
    buildingHash: 'cave',
    buildingId: 'cave',
    descriptionKey: 'cave_description'
  }
];
